import { debounce } from "../utilities"
import KeenSlider from "keen-slider"

export default class {
  constructor(el) {
    const items = Array.from(el?.children)

    const MIN_TO_SCROLL = 3
    const MIN_TO_SLIDE = 3

    if (items.length <= MIN_TO_SLIDE) return

    var animation = { duration: items.length * 7000, easing: (t) => t }

    const slider = new KeenSlider(el, {
      initial: 0,
      loop: items.length > 1,
      renderMode: "performance",
      created(s) {
        if (items.length <= MIN_TO_SCROLL) return
        s.moveToIdx(5, true, animation)
      },
      updated(s) {
        if (items.length <= MIN_TO_SCROLL) return
        s.moveToIdx(s.track.details.abs + items.length, true, animation)
      },
      animationEnded(s) {
        if (items.length <= MIN_TO_SCROLL) return
        s.moveToIdx(s.track.details.abs + items.length, true, animation)
      },
      selector: ".js-scrollerItem",
      slides: {
        perView: "auto",
        spacing: -1,
      },
    })

    window.addEventListener(
      "resize",
      debounce(() => slider.update(), 250),
    )
  }
}

// import { prefersReducedMotion } from "../utilities"

// export default class {
//   constructor(el) {
//     if (prefersReducedMotion) {
//       el.style.overflowX = "scroll"
//       return
//     }

//     let now
//     let then
//     let elapsed
//     let fpsInterval
//     let direction = "right"
//     let stop = false

//     function getScrollPos() {
//       return (el.pageXOffset || el.scrollLeft) - (el.clientLeft || 0)
//     }

//     function setScrollPos(pos) {
//       el.scrollTo(pos, 0)

//       if (pos >= el.scrollWidth - el.clientWidth) {
//         direction = "left"
//       }

//       if (pos <= 0) {
//         direction = "right"
//       }
//     }

//     function startScrolling(fps) {
//       fpsInterval = 1000 / fps
//       then = window.performance.now()
//       animate()
//     }

//     function animate(newtime) {
//       if (stop === true) {
//         return
//       }

//       window.requestAnimationFrame(animate)

//       now = newtime
//       elapsed = now - then

//       if (elapsed > fpsInterval) {
//         then = now - (elapsed % fpsInterval)

//         setScrollPos(
//           direction === "right"
//             ? getScrollPos() + 1
//             : direction === "left"
//             ? getScrollPos() - 1
//             : getScrollPos(),
//         )
//       }
//     }

//     startScrolling(120)

//     function stopScroll() {
//       stop = true
//       el.removeEventListener("wheel", onWheel)
//       el.removeEventListener("touchstart", onTouchStart)
//       el.removeEventListener("touchmove", onTouchMove)
//     }

//     const onWheel = el.addEventListener(
//       "wheel",
//       (e) => {
//         if (e.deltaX !== 0) {
//           stopScroll()
//         }
//       },
//       {
//         passive: true,
//       },
//     )
//     const onTouchStart = el.addEventListener("touchstart", touchStart, false)
//     const onTouchMove = el.addEventListener("touchmove", touchMove, false)

//     let start = 0
//     let offset = 0

//     function touchStart(event) {
//       start = event.touches[0].pageX
//     }

//     function touchMove(event) {
//       offset = start - event.touches[0].pageX

//       if (Math.abs(offset) > 40) {
//         stopScroll()
//       }
//     }
//   }
// }
